import Row from 'blocks/Row';
import { getAlphabetDate, getTime } from 'helper/date';
import { useTranslation } from 'react-i18next';
import { RouteDetailProps } from './routeDetail.interface';
import * as S from './routeDetail.styles';

const RouteFreeTicketDetail = ({ freeTicket, showPNR, bookRequest }: RouteDetailProps) => {
  if (!freeTicket) return null;
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { t } = useTranslation();
  return (
    <S.RouteDetail>
      <Row justify="space-between">
        {showPNR && (
          <S.Name2>
            {t('pages.miles.claim.sections.flightRecords.modals.flightDetails.airlinePNR')} {freeTicket.PNR}
          </S.Name2>
        )}
      </Row>

      <S.RowFlightDetail>
        <S.RowFlightDetail className="route">
          {bookRequest.OTA_AirBookRQ.AirItinerary.OriginDestinationOptions.OriginDestinationOption.map((item) => {
            return (
              <div>
                <S.TextBlue>
                  {t('pages.miles.claim.sections.flightRecords.modals.flightDetails.flightTo')}{' '}
                  {item[0].FlightSegment.ArrivalAirport.$.LocationCode}
                  {freeTicket.RDB ? `(${freeTicket.RDB})` : ''}
                </S.TextBlue>
                <S.Form>
                  <S.Bullet>
                    <S.BulletSpan></S.BulletSpan>
                  </S.Bullet>
                  <S.FormInfo>
                    <S.FlightFlightDate>
                      {getAlphabetDate(item[0].FlightSegment.$.DepartureDateTime)} .
                      {getTime(item[0].FlightSegment.$.DepartureDateTime, 0)}
                    </S.FlightFlightDate>
                    <S.FlightDeparture>{item[0].FlightSegment.DepartureAirport.$.LocationCode}</S.FlightDeparture>
                  </S.FormInfo>
                </S.Form>

                <S.To>
                  <S.Bullet>
                    <S.BulletSpan2></S.BulletSpan2>
                  </S.Bullet>
                  <S.FlightFlightToInfo>
                    <S.FlightFlightDate>
                      {getAlphabetDate(item[0].FlightSegment.$.ArrivalDateTime)} .{' '}
                      {getTime(item[0].FlightSegment.$.ArrivalDateTime, 0)}
                    </S.FlightFlightDate>
                    <S.FlightDeparture>{item[0].FlightSegment.ArrivalAirport.$.LocationCode}</S.FlightDeparture>
                  </S.FlightFlightToInfo>
                </S.To>
              </div>
            );
          })}
        </S.RowFlightDetail>
      </S.RowFlightDetail>
    </S.RouteDetail>
  );
};

export default RouteFreeTicketDetail;
